import { section } from '@/glow';

import Carousel from '@/lib/carousel';

section('social-proof', {
  onLoad() {
    const carouselWraps = this.container.dataset.carouselWraps === 'true';

    this.carousel = Carousel(this.container, {
      wrapAround: carouselWraps,
      adaptiveHeight: false,
    });
  },

  onUnload() {
    this.carousel.destroy();
  },

  onBlockSelect({ target: item }) {
    this.carousel.select(item.dataset.index);
  },
});
